import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Image as Image$1 } from 'frontend-image';
import { Card } from '@andes/card';
import { MoneyAmountCombo } from '@andes/money-amount';
import InputStepper from '@andes/input-stepper';
import { Button } from '@andes/button';
import { Image } from '@mshops-components-library/common';
import { Thumbnail } from '@andes/thumbnail';
import { Dropdown, DropdownItem } from '@andes/dropdown';
import { Dot } from '@andes/badge';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
var REACT_ELEMENT_TYPE$2;
function _createRawReactElement$1(e, r, E, l) {
  REACT_ELEMENT_TYPE$2 || (REACT_ELEMENT_TYPE$2 = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE$2,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function createCommonjsModule$1(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function (path, base) {
      return commonjsRequire(path, base === undefined || base === null ? module.path : base);
    }
  }, fn(module, module.exports), module.exports;
}
function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}
var _typeof_1 = createCommonjsModule$1(function (module) {
  function _typeof(o) {
    "@babel/helpers - typeof";

    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
  }
  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var regeneratorRuntime$1 = createCommonjsModule$1(function (module) {
  var _typeof = _typeof_1["default"];
  function _regeneratorRuntime() {
    module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
      return r;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t,
      r = {},
      e = Object.prototype,
      n = e.hasOwnProperty,
      o = "function" == typeof Symbol ? Symbol : {},
      i = o.iterator || "@@iterator",
      a = o.asyncIterator || "@@asyncIterator",
      u = o.toStringTag || "@@toStringTag";
    function c(t, r, e, n) {
      return Object.defineProperty(t, r, {
        value: e,
        enumerable: !n,
        configurable: !n,
        writable: !n
      });
    }
    try {
      c({}, "");
    } catch (t) {
      c = function c(t, r, e) {
        return t[r] = e;
      };
    }
    function h(r, e, n, o) {
      var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype);
      return c(a, "_invoke", function (r, e, n) {
        var o = 1;
        return function (i, a) {
          if (3 === o) throw Error("Generator is already running");
          if (4 === o) {
            if ("throw" === i) throw a;
            return {
              value: t,
              done: !0
            };
          }
          for (n.method = i, n.arg = a;;) {
            var u = n.delegate;
            if (u) {
              var c = d(u, n);
              if (c) {
                if (c === f) continue;
                return c;
              }
            }
            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (1 === o) throw o = 4, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = 3;
            var h = s(r, e, n);
            if ("normal" === h.type) {
              if (o = n.done ? 4 : 2, h.arg === f) continue;
              return {
                value: h.arg,
                done: n.done
              };
            }
            "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
          }
        };
      }(r, n, new Context(o || [])), !0), a;
    }
    function s(t, r, e) {
      try {
        return {
          type: "normal",
          arg: t.call(r, e)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }
    r.wrap = h;
    var f = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var l = {};
    c(l, i, function () {
      return this;
    });
    var p = Object.getPrototypeOf,
      y = p && p(p(x([])));
    y && y !== e && n.call(y, i) && (l = y);
    var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
    function g(t) {
      ["next", "throw", "return"].forEach(function (r) {
        c(t, r, function (t) {
          return this._invoke(r, t);
        });
      });
    }
    function AsyncIterator(t, r) {
      function e(o, i, a, u) {
        var c = s(t[o], t, i);
        if ("throw" !== c.type) {
          var h = c.arg,
            f = h.value;
          return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) {
            e("next", t, a, u);
          }, function (t) {
            e("throw", t, a, u);
          }) : r.resolve(f).then(function (t) {
            h.value = t, a(h);
          }, function (t) {
            return e("throw", t, a, u);
          });
        }
        u(c.arg);
      }
      var o;
      c(this, "_invoke", function (t, n) {
        function i() {
          return new r(function (r, o) {
            e(t, n, r, o);
          });
        }
        return o = o ? o.then(i, i) : i();
      }, !0);
    }
    function d(r, e) {
      var n = e.method,
        o = r.i[n];
      if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
      var i = s(o, r.i, e.arg);
      if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
      var a = i.arg;
      return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
    }
    function w(t) {
      this.tryEntries.push(t);
    }
    function m(r) {
      var e = r[4] || {};
      e.type = "normal", e.arg = t, r[4] = e;
    }
    function Context(t) {
      this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0);
    }
    function x(r) {
      if (null != r) {
        var e = r[i];
        if (e) return e.call(r);
        if ("function" == typeof r.next) return r;
        if (!isNaN(r.length)) {
          var o = -1,
            a = function e() {
              for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
              return e.value = t, e.done = !0, e;
            };
          return a.next = a;
        }
      }
      throw new TypeError(_typeof(r) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) {
      var r = "function" == typeof t && t.constructor;
      return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
    }, r.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
    }, r.awrap = function (t) {
      return {
        __await: t
      };
    }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () {
      return this;
    }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new AsyncIterator(h(t, e, n, o), i);
      return r.isGeneratorFunction(e) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, g(v), c(v, u, "Generator"), c(v, i, function () {
      return this;
    }), c(v, "toString", function () {
      return "[object Generator]";
    }), r.keys = function (t) {
      var r = Object(t),
        e = [];
      for (var n in r) e.unshift(n);
      return function t() {
        for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
        return t.done = !0, t;
      };
    }, r.values = x, Context.prototype = {
      constructor: Context,
      reset: function reset(r) {
        if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0][4];
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(r) {
        if (this.done) throw r;
        var e = this;
        function n(t) {
          a.type = "throw", a.arg = r, e.next = t;
        }
        for (var o = e.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
            a = i[4],
            u = this.prev,
            c = i[1],
            h = i[2];
          if (-1 === i[0]) return n("end"), !1;
          if (!c && !h) throw Error("try statement without catch or finally");
          if (null != i[0] && i[0] <= u) {
            if (u < c) return this.method = "next", this.arg = t, n(c), !0;
            if (u < h) return n(h), !1;
          }
        }
      },
      abrupt: function abrupt(t, r) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e];
          if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
            var o = n;
            break;
          }
        }
        o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
        var i = o ? o[4] : {};
        return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
      },
      complete: function complete(t, r) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
      },
      finish: function finish(t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var e = this.tryEntries[r];
          if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
        }
      },
      "catch": function _catch(t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var e = this.tryEntries[r];
          if (e[0] === t) {
            var n = e[4];
            if ("throw" === n.type) {
              var o = n.arg;
              m(e);
            }
            return o;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(r, e, n) {
        return this.delegate = {
          i: x(r),
          r: e,
          n: n
        }, "next" === this.method && (this.arg = t), f;
      }
    }, r;
  }
  module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var runtime = regeneratorRuntime$1();
var regenerator = runtime;
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
function _typeof(o) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function createCommonjsModule(fn, basedir, module) {
  return fn(module = {
    path: basedir,
    exports: {},
    require: function (path, base) {
      return function () {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }(null == base && module.path);
    }
  }, module.exports), module.exports;
}
var b = "function" == typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === _typeof(a) && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
var reactIs_production_min = {
    AsyncMode: l,
    ConcurrentMode: m,
    ContextConsumer: k,
    ContextProvider: h,
    Element: c,
    ForwardRef: n,
    Fragment: e,
    Lazy: t,
    Memo: r,
    Portal: d,
    Profiler: g,
    StrictMode: f,
    Suspense: p,
    isAsyncMode: function (a) {
      return A(a) || z(a) === l;
    },
    isConcurrentMode: A,
    isContextConsumer: function (a) {
      return z(a) === k;
    },
    isContextProvider: function (a) {
      return z(a) === h;
    },
    isElement: function (a) {
      return "object" === _typeof(a) && null !== a && a.$$typeof === c;
    },
    isForwardRef: function (a) {
      return z(a) === n;
    },
    isFragment: function (a) {
      return z(a) === e;
    },
    isLazy: function (a) {
      return z(a) === t;
    },
    isMemo: function (a) {
      return z(a) === r;
    },
    isPortal: function (a) {
      return z(a) === d;
    },
    isProfiler: function (a) {
      return z(a) === g;
    },
    isStrictMode: function (a) {
      return z(a) === f;
    },
    isSuspense: function (a) {
      return z(a) === p;
    },
    isValidElementType: function (a) {
      return "string" == typeof a || "function" == typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    },
    typeOf: z
  },
  reactIs_development = createCommonjsModule(function (module, exports) {
    "production" !== process.env.NODE_ENV && function () {
      var hasSymbol = "function" == typeof Symbol && Symbol.for,
        REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103,
        REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106,
        REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107,
        REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108,
        REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114,
        REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109,
        REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110,
        REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111,
        REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111,
        REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112,
        REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113,
        REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120,
        REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115,
        REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116,
        REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121,
        REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117,
        REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118,
        REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function typeOf(object) {
        if ("object" === _typeof(object) && null !== object) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE,
        ConcurrentMode = REACT_CONCURRENT_MODE_TYPE,
        ContextConsumer = REACT_CONTEXT_TYPE,
        ContextProvider = REACT_PROVIDER_TYPE,
        Element = REACT_ELEMENT_TYPE,
        ForwardRef = REACT_FORWARD_REF_TYPE,
        Fragment = REACT_FRAGMENT_TYPE,
        Lazy = REACT_LAZY_TYPE,
        Memo = REACT_MEMO_TYPE,
        Portal = REACT_PORTAL_TYPE,
        Profiler = REACT_PROFILER_TYPE,
        StrictMode = REACT_STRICT_MODE_TYPE,
        Suspense = REACT_SUSPENSE_TYPE,
        hasWarnedAboutDeprecatedIsAsyncMode = !1;
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      exports.AsyncMode = AsyncMode, exports.ConcurrentMode = ConcurrentMode, exports.ContextConsumer = ContextConsumer, exports.ContextProvider = ContextProvider, exports.Element = Element, exports.ForwardRef = ForwardRef, exports.Fragment = Fragment, exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, exports.Profiler = Profiler, exports.StrictMode = StrictMode, exports.Suspense = Suspense, exports.isAsyncMode = function (object) {
        return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }, exports.isConcurrentMode = isConcurrentMode, exports.isContextConsumer = function (object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }, exports.isContextProvider = function (object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }, exports.isElement = function (object) {
        return "object" === _typeof(object) && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
      }, exports.isForwardRef = function (object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }, exports.isFragment = function (object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }, exports.isLazy = function (object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }, exports.isMemo = function (object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }, exports.isPortal = function (object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }, exports.isProfiler = function (object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }, exports.isStrictMode = function (object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }, exports.isSuspense = function (object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }, exports.isValidElementType = function (type) {
        return "string" == typeof type || "function" == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === _typeof(type) && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }, exports.typeOf = typeOf;
    }();
  }),
  reactIs = createCommonjsModule(function (module) {
    "production" === process.env.NODE_ENV ? module.exports = reactIs_production_min : module.exports = reactIs_development;
  }),
  getOwnPropertySymbols = Object.getOwnPropertySymbols,
  hasOwnProperty = Object.prototype.hasOwnProperty,
  propIsEnumerable = Object.prototype.propertyIsEnumerable;
var objectAssign = function () {
    try {
      if (!Object.assign) return !1;
      var test1 = new String("abc");
      if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
      for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if ("0123456789" !== order2.join("")) return !1;
      var test3 = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (letter) {
        test3[letter] = letter;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
    } catch (err) {
      return !1;
    }
  }() ? Object.assign : function (target, source) {
    for (var from, symbols, to = function (val) {
        if (null == val) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(val);
      }(target), s = 1; s < arguments.length; s++) {
      for (var key in from = Object(arguments[s])) hasOwnProperty.call(from, key) && (to[key] = from[key]);
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
      }
    }
    return to;
  },
  has$2 = Function.call.bind(Object.prototype.hasOwnProperty),
  ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  has$1 = has$2,
  printWarning$1 = function () {};
if ("production" !== process.env.NODE_ENV) {
  var ReactPropTypesSecret = ReactPropTypesSecret$1,
    loggedTypeFailures = {},
    has = has$1;
  printWarning$1 = function (text) {
    var message = "Warning: " + text;
    "undefined" != typeof console && console.error(message);
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if ("production" !== process.env.NODE_ENV) for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
    var error;
    try {
      if ("function" != typeof typeSpecs[typeSpecName]) {
        var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _typeof(typeSpecs[typeSpecName]) + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
        throw err.name = "Invariant Violation", err;
      }
      error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
    } catch (ex) {
      error = ex;
    }
    if (!error || error instanceof Error || printWarning$1((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + _typeof(error) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), error instanceof Error && !(error.message in loggedTypeFailures)) {
      loggedTypeFailures[error.message] = !0;
      var stack = getStack ? getStack() : "";
      printWarning$1("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
    }
  }
}
checkPropTypes$1.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (loggedTypeFailures = {});
};
var checkPropTypes = checkPropTypes$1,
  printWarning = function () {};
function emptyFunctionThatReturnsNull() {
  return null;
}
"production" !== process.env.NODE_ENV && (printWarning = function (text) {
  var message = "Warning: " + text;
  "undefined" != typeof console && console.error(message);
  try {
    throw new Error(message);
  } catch (x) {}
});
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var require$$1 = function (isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator;
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createChainableTypeChecker(emptyFunctionThatReturnsNull),
      arrayOf: function (typeChecker) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          var propValue = props[propName];
          if (!Array.isArray(propValue)) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret$1);
            if (error instanceof Error) return error;
          }
          return null;
        });
      },
      element: createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        return isValidElement(propValue) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
      }),
      elementType: createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        return reactIs.isValidElementType(propValue) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
      }),
      instanceOf: function (expectedClass) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || "<<anonymous>>";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + (((propValue = props[propName]).constructor && propValue.constructor.name ? propValue.constructor.name : "<<anonymous>>") + "` supplied to `") + componentName + "`, expected instance of `" + expectedClassName + "`.");
          }
          var propValue;
          return null;
        });
      },
      node: createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
      }),
      objectOf: function (typeChecker) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          var propValue = props[propName],
            propType = getPropType(propValue);
          if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
          for (var key in propValue) if (has$1(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret$1);
            if (error instanceof Error) return error;
          }
          return null;
        });
      },
      oneOf: function (expectedValues) {
        if (!Array.isArray(expectedValues)) return "production" !== process.env.NODE_ENV && printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), emptyFunctionThatReturnsNull;
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
          var valuesString = JSON.stringify(expectedValues, function (key, value) {
            return "symbol" === getPreciseType(value) ? String(value) : value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
        });
      },
      oneOfType: function (arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) return "production" !== process.env.NODE_ENV && printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), emptyFunctionThatReturnsNull;
        }
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          for (var expectedTypes = [], i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checkerResult = (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
            if (null == checkerResult) return null;
            checkerResult.data && has$1(checkerResult.data, "expectedType") && expectedTypes.push(checkerResult.data.expectedType);
          }
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`" + (expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "") + ".");
        });
      },
      shape: function (shapeTypes) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          var propValue = props[propName],
            propType = getPropType(propValue);
          if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if ("function" != typeof checker) return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret$1);
            if (error) return error;
          }
          return null;
        });
      },
      exact: function (shapeTypes) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          var propValue = props[propName],
            propType = getPropType(propValue);
          if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
          var allKeys = objectAssign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has$1(shapeTypes, key) && "function" != typeof checker) return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret$1);
            if (error) return error;
          }
          return null;
        });
      }
    };
    function is(x, y) {
      return x === y ? 0 !== x || 1 / x == 1 / y : x != x && y != y;
    }
    function PropTypeError(message, data) {
      this.message = message, this.data = data && "object" === _typeof(data) ? data : {}, this.stack = "";
    }
    function createChainableTypeChecker(validate) {
      if ("production" !== process.env.NODE_ENV) var manualPropTypeCallCache = {},
        manualPropTypeWarningCount = 0;
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        if (componentName = componentName || "<<anonymous>>", propFullName = propFullName || propName, secret !== ReactPropTypesSecret$1) {
          if (throwOnDirectAccess) {
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw err.name = "Invariant Violation", err;
          }
          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var cacheKey = componentName + ":" + propName;
            !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
          }
        }
        return null == props[propName] ? isRequired ? null === props[propName] ? new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`.") : new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
      }
      var chainedCheckType = checkType.bind(null, !1);
      return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      return createChainableTypeChecker(function (props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        return getPropType(propValue) !== expectedType ? new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.", {
          expectedType: expectedType
        }) : null;
      });
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function isNode(propValue) {
      switch (_typeof(propValue)) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) return propValue.every(isNode);
          if (null === propValue || isValidElement(propValue)) return !0;
          var iteratorFn = function (maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable["@@iterator"]);
            if ("function" == typeof iteratorFn) return iteratorFn;
          }(propValue);
          if (!iteratorFn) return !1;
          var step,
            iterator = iteratorFn.call(propValue);
          if (iteratorFn !== propValue.entries) {
            for (; !(step = iterator.next()).done;) if (!isNode(step.value)) return !1;
          } else for (; !(step = iterator.next()).done;) {
            var entry = step.value;
            if (entry && !isNode(entry[1])) return !1;
          }
          return !0;
        default:
          return !1;
      }
    }
    function getPropType(propValue) {
      var propType = _typeof(propValue);
      return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : function (propType, propValue) {
        return "symbol" === propType || !!propValue && ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
      }(propType, propValue) ? "symbol" : propType;
    }
    function getPreciseType(propValue) {
      if (null == propValue) return "" + propValue;
      var propType = getPropType(propValue);
      if ("object" === propType) {
        if (propValue instanceof Date) return "date";
        if (propValue instanceof RegExp) return "regexp";
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
  },
  require$$2 = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret !== ReactPropTypesSecret$1) {
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw err.name = "Invariant Violation", err;
      }
    }
    function getShim() {
      return shim;
    }
    shim.isRequired = shim;
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    return ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
  },
  PropTypes = createCommonjsModule(function (module) {
    if ("production" !== process.env.NODE_ENV) {
      var ReactIs = reactIs;
      module.exports = require$$1(ReactIs.isElement, !0);
    } else module.exports = require$$2();
  });
var REACT_ELEMENT_TYPE$1;
function _jsx(e, r, E, l) {
  REACT_ELEMENT_TYPE$1 || (REACT_ELEMENT_TYPE$1 = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE$1,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
var Full = function (_ref) {
  return _jsx("svg", {
    className: _ref.className,
    width: _ref.width,
    height: _ref.height,
    viewBox: "0 0 41 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _jsx("path", {
    fill: _ref.color,
    fillRule: "nonzero",
    d: "M2.628 0h5.255L5.255 4.643h4.38L2.628 13l1.751-5.571H0L2.628 0zm11.589 9.533h-1.959l1.674-7.515H19.5l-.376 1.69h-3.61l-.25 1.172h3.519l-.376 1.69h-3.53l-.66 2.963zm9.468.136c-2.334 0-3.484-1.105-3.484-2.682 0-.124.034-.383.057-.496l1.002-4.473h1.992l-.99 4.428c-.012.057-.034.18-.034.316.011.62.49 1.217 1.457 1.217 1.048 0 1.583-.654 1.776-1.533l.991-4.428h1.981l-.99 4.462c-.41 1.825-1.412 3.189-3.758 3.189zm10.118-.136h-5.01l1.673-7.515h1.959l-1.287 5.825h3.04l-.375 1.69zm6.678 0h-5.01l1.674-7.515h1.959l-1.287 5.825h3.04l-.376 1.69z"
  }));
};
Full.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string
}, Full.defaultProps = {
  className: null,
  width: "41px",
  height: "13px",
  color: "rgba(0, 0, 0, 0.8)"
};
var TYPES = {
  SELLER: 'seller',
  SUPER: 'super',
  SUPER_PARTNER: 'super_partner',
  BRAND: 'brand',
  DEFAULT: 'eshop',
  LANDING: 'landing'
};
var VARIANTS_BUTTONS = {
  NEUTRAL: 'neutral',
  SECONDARY: 'secondary'
};
var VAR_CSS = {
  VAR_BUTTON_NEUTRAL_IDLE_COLOR: 'var(--button-neutral-idle-color, var(--colorTextVar))',
  VAR_COLOR_OR_BLACK_BY_PRIMARY_COLOR: 'var(--colorOrBlackByPrimaryColor)',
  VAR_PRIMARY_TEXT_COLOR_VAR: 'var(--primaryTextColorVar)'
};
var ANDES_BLUE_500 = '#3483FA';
var constants = {
  TYPES: TYPES,
  VARIANTS_BUTTONS: VARIANTS_BUTTONS,
  VAR_CSS: VAR_CSS,
  ANDES_BLUE_500: ANDES_BLUE_500
};
var CardAction = function CardAction(_ref) {
  var namespace = _ref.namespace,
    layout = _ref.layout,
    shouldAddToCart = _ref.shouldAddToCart,
    relevant = _ref.relevant,
    variationsCta = _ref.variationsCta,
    cta = _ref.cta,
    itemQuantity = _ref.itemQuantity,
    hasMoreVariations = _ref.hasMoreVariations,
    netWeight = _ref.netWeight,
    purchaseMaxQuantity = _ref.purchaseMaxQuantity,
    incrementQuantity = _ref.incrementQuantity,
    decrementQuantity = _ref.decrementQuantity,
    deviceType = _ref.deviceType,
    cartTextLabel = _ref.cartTextLabel,
    osName = _ref.osName;
  var isDesktop = deviceType === 'desktop';
  var isIos = (osName === null || osName === void 0 ? void 0 : osName.toLowerCase()) === 'ios';
  var incrementButtonProps = {
    onClick: incrementQuantity
  };
  var decrementButtonProps = {
    onClick: decrementQuantity
  };
  var setUnit = function setUnit(quantity) {
    var val = quantity * netWeight.number;
    if (val >= 1000) {
      return "".concat(val / 1000, " kg");
    }
    return "".concat(val, " ").concat(netWeight.unit);
  };
  var convertQuantityToUnit = function convertQuantityToUnit(quantity) {
    if (netWeight) {
      return setUnit(quantity);
    }
    return quantity;
  };
  if (itemQuantity > 0 && !hasMoreVariations) {
    return /*#__PURE__*/_createRawReactElement$1(InputStepper, {
      formatValue: convertQuantityToUnit,
      value: itemQuantity,
      size: "small",
      step: 1,
      maxValue: purchaseMaxQuantity,
      decrementButtonProps: decrementButtonProps,
      incrementButtonProps: incrementButtonProps,
      complementaryText: !netWeight && isDesktop ? cartTextLabel : null
    });
  }
  if (isIos) {
    return /*#__PURE__*/_createRawReactElement$1("button", {
      className: "".concat(namespace, "__cta-button--").concat(layout, " ").concat(namespace, "__cta-button--ios"),
      onClick: shouldAddToCart
    }, void 0, /*#__PURE__*/_createRawReactElement$1("span", {
      className: "andes-button__content"
    }, void 0, hasMoreVariations ? variationsCta : cta));
  }
  return /*#__PURE__*/_createRawReactElement$1(Button, {
    className: "".concat(namespace, "__cta-button--").concat(layout),
    onClick: shouldAddToCart,
    hierarchy: relevant ? 'loud' : 'quiet',
    size: "medium",
    fullWidth: layout === 'column'
  }, void 0, hasMoreVariations ? variationsCta : cta);
};
CardAction.defaultProps = {
  netWeight: null
};
var CardAction$1 = CardAction;
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
const Asset$1 = _ref => {
  let {
    color = "rgba(0, 0, 0, 0.9)",
    i18n: i18n,
    srLabel: srLabel
  } = _ref;
  return _createRawReactElement("svg", {
    "aria-hidden": srLabel ? void 0 : !srLabel,
    "aria-label": srLabel || void 0,
    role: srLabel ? "img" : void 0,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: color
  }, void 0, srLabel && _createRawReactElement("title", {}, void 0, srLabel), _createRawReactElement("path", {
    d: "M8.12213 2.6525C8.8218 1.85372 9.72954 1.39868 11.0019 1.39868C13.4467 1.39868 15.1196 2.98206 15.1196 5.9989C15.1196 6.05766 15.1184 6.11656 15.1159 6.17559C15.0376 8.07474 13.7491 10.0099 11.6672 11.9305C10.9348 12.6061 10.1523 13.2325 9.36995 13.7952C9.09599 13.9923 8.84127 14.1675 8.6121 14.3191C8.47311 14.411 8.37243 14.4752 8.31638 14.5098L8.00108 14.7046L7.68564 14.5097L7.66347 14.4959L7.60517 14.459C7.54278 14.4192 7.47081 14.3725 7.39006 14.3191C7.1609 14.1675 6.90618 13.9923 6.63222 13.7952C5.84982 13.2325 5.06737 12.6061 4.33499 11.9305C2.2531 10.0099 0.964595 8.07474 0.886227 6.17559C0.883791 6.11656 0.882568 6.05766 0.882568 5.9989C0.882568 2.98206 2.55542 1.39868 5.00025 1.39868C6.27262 1.39868 7.18036 1.85372 7.88004 2.6525C7.91191 2.6889 7.95385 2.7408 8.00108 2.80134C8.04831 2.7408 8.09025 2.6889 8.12213 2.6525Z",
    fill: color
  }));
};
const Asset = _ref => {
  let {
    color = "rgba(0, 0, 0, 0.9)",
    i18n: i18n,
    srLabel: srLabel
  } = _ref;
  return _createRawReactElement("svg", {
    "aria-hidden": srLabel ? void 0 : !srLabel,
    "aria-label": srLabel || void 0,
    role: srLabel ? "img" : void 0,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: color
  }, void 0, srLabel && _createRawReactElement("title", {}, void 0, srLabel), _createRawReactElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0019 1.39868C9.72954 1.39868 8.8218 1.85372 8.12213 2.6525C8.09025 2.6889 8.04831 2.7408 8.00108 2.80134C7.95385 2.7408 7.91191 2.6889 7.88004 2.6525C7.18036 1.85372 6.27262 1.39868 5.00025 1.39868C2.55542 1.39868 0.882568 2.98206 0.882568 5.9989C0.882568 6.05766 0.883791 6.11656 0.886227 6.17559C0.964595 8.07474 2.2531 10.0099 4.33499 11.9305C5.06737 12.6061 5.84982 13.2325 6.63222 13.7952C6.90618 13.9923 7.1609 14.1675 7.39006 14.3191C7.47081 14.3725 7.54278 14.4192 7.60517 14.459L7.66347 14.4959L7.68578 14.5098L8.00108 14.7046L8.31638 14.5098C8.37243 14.4752 8.47311 14.411 8.6121 14.3191C8.84127 14.1675 9.09599 13.9923 9.36995 13.7952C10.1523 13.2325 10.9348 12.6061 11.6672 11.9305C13.7491 10.0099 15.0376 8.07474 15.1159 6.17559C15.1184 6.11656 15.1196 6.05766 15.1196 5.9989C15.1196 2.98206 13.4467 1.39868 11.0019 1.39868ZM10.8535 11.0484C10.16 11.6882 9.41463 12.2849 8.66925 12.8211C8.42872 12.9941 8.20432 13.149 8.00108 13.2844C7.79784 13.149 7.57344 12.9941 7.33291 12.8211C6.58753 12.2849 5.8422 11.6882 5.14866 11.0484C3.28055 9.32513 2.14696 7.62261 2.08521 6.12612C2.08345 6.08351 2.08257 6.04111 2.08257 5.9989C2.08257 3.66 3.20386 2.59868 5.00025 2.59868C5.9084 2.59868 6.49537 2.89293 6.97736 3.44318C7.13263 3.62045 7.68637 4.40068 7.51851 4.1735L8.00108 4.82662L8.48365 4.1735C8.31579 4.40068 8.86953 3.62045 9.0248 3.44318C9.50679 2.89293 10.0938 2.59868 11.0019 2.59868C12.7983 2.59868 13.9196 3.66 13.9196 5.9989C13.9196 6.04111 13.9187 6.08351 13.917 6.12612C13.8552 7.62261 12.7216 9.32513 10.8535 11.0484Z",
    fill: color
  }));
};
var BookmarkButton = function BookmarkButton(_ref) {
  var onClickBookmark = _ref.onClickBookmark,
    bookmarked = _ref.bookmarked,
    addBookmarkLabel = _ref.addBookmarkLabel;
  var Icon = !bookmarked ? Asset : Asset$1;
  var classNames = 'ui-eshop-bookmark';
  return /*#__PURE__*/_createRawReactElement$1("button", {
    className: classNames,
    onClick: onClickBookmark,
    "aria-label": addBookmarkLabel
  }, void 0, /*#__PURE__*/_createRawReactElement$1(Icon, {
    color: "#3483fa"
  }));
};
BookmarkButton.defaultProps = {
  bookmarked: false,
  onClickBookmark: null,
  addBookmarkLabel: 'Favorito'
};
var BookmarkButton$1 = BookmarkButton;
var _Dot;
var Variations = function Variations(_ref) {
  var sortedVariationData = _ref.sortedVariationData,
    layout = _ref.layout,
    setItemImage = _ref.setItemImage,
    setItemLink = _ref.setItemLink,
    itemImage = _ref.itemImage,
    setItemName = _ref.setItemName,
    itemName = _ref.itemName,
    trackingId = _ref.trackingId,
    onClick = _ref.onClick,
    variationId = _ref.variationId,
    setVariationId = _ref.setVariationId;
  var namespace = 'ui-eshop-variation';
  var SliceQuantity = sortedVariationData.length > 4 ? 3 : 4;
  var selectVariation = function selectVariation(event, item) {
    var _event$preventDefault;
    event === null || event === void 0 || (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
    var image = item.image,
      url = item.url,
      name = item.name,
      id = item.id;
    var newVariationUrl = url === null || url === void 0 ? void 0 : url.replace('{tracking_id}', trackingId);
    setItemImage(image);
    setItemLink(newVariationUrl);
    setItemName(name);
    setVariationId(id);
  };
  var squares = sortedVariationData.slice(0, SliceQuantity).map(function (item) {
    return /*#__PURE__*/_createRawReactElement$1("button", {
      onClick: function onClick(event) {
        return selectVariation(event, item);
      },
      className: "".concat(namespace, "__thumbnail-button")
    }, item.id, /*#__PURE__*/_createRawReactElement$1(Thumbnail, {
      modifier: "square",
      size: "48",
      badge: itemImage === item.image ? _Dot || (_Dot = /*#__PURE__*/_createRawReactElement$1(Dot, {})) : null,
      srLabel: item.name,
      className: "".concat(namespace, "__link")
    }, void 0, /*#__PURE__*/_createRawReactElement$1(Image, {
      src: item === null || item === void 0 ? void 0 : item.image,
      alt: item === null || item === void 0 ? void 0 : item.name,
      className: "".concat(namespace, "__image")
    })));
  });
  if (sortedVariationData.length > 4) {
    squares.push(/*#__PURE__*/_createRawReactElement$1("div", {
      onClick: onClick
    }, "more", /*#__PURE__*/_createRawReactElement$1(Thumbnail, {
      modifier: "square",
      size: "48",
      className: "".concat(namespace, "__link")
    }, void 0, /*#__PURE__*/_createRawReactElement$1("span", {
      className: "".concat(namespace, "__link ").concat(namespace, "__link--last")
    }, void 0, "+", sortedVariationData.length - 3))));
  }
  return /*#__PURE__*/_createRawReactElement$1("div", {
    className: "".concat(namespace, "__container")
  }, void 0, layout === 'column' ? squares : /*#__PURE__*/_createRawReactElement$1(Dropdown, {
    srLabel: "id-for-label-dropdown",
    label: itemName,
    position: false,
    size: "compact",
    value: itemImage,
    options: sortedVariationData.map(function (item) {
      return {
        optionType: 'item',
        primary: item.name,
        value: item.id
      };
    }),
    placeholder: "Selecciona una opci\xF3n",
    onChange: function onChange(event) {
      return selectVariation(event, event.target.value);
    }
  }, variationId, sortedVariationData.map(function (item) {
    return /*#__PURE__*/_createRawReactElement$1(DropdownItem, {
      title: item.name,
      value: item
    }, item.id);
  })));
};
Variations.defaultProps = {
  trackingId: 'none'
};
var Variations$1 = Variations;
var formatNumber = function formatNumber(number, currencyId) {
  var parts = number.toString().split('.');
  var wholeSeparator = currencyId === 'MXN' ? ',' : '.';
  var decimalSeparator = currencyId === 'MXN' ? '.' : ',';
  var formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, wholeSeparator);
  var decimal = parts[1] || '';
  if (decimal === '0' || decimal.startsWith('00', 0)) {
    decimal = '';
  }
  if (decimal.length === 1) {
    decimal = "".concat(decimalSeparator + decimal, "0");
  } else if (decimal.length === 2) {
    decimal = decimalSeparator + parts[1];
  } else if (decimal.length > 2) {
    decimal = decimalSeparator + parts[1].slice(0, 2);
  }
  return "".concat(formattedInteger).concat(decimal);
};
var generateInstallments = function generateInstallments(installments, installmentsData) {
  var hasInterest = installmentsData.rate > 0;
  var hasInString = /^en.*$|^em.*$/.test(installments.toLowerCase());
  return {
    hasInterest: hasInterest,
    hasInString: hasInString
  };
};
var isDeepLink = function isDeepLink(link) {
  return link.startsWith('meli://') || link.startsWith('mercadopago://');
};
var isDeepLink$1 = isDeepLink;
var newDeepLink = function newDeepLink(relevantId, relevantType, trackingId, variationId, d2id) {
  if (relevantType === 'item') {
    var variationSegment = '';
    if (variationId) {
      variationSegment = "&variation_id=".concat(variationId);
    }
    return "meli://items-core/".concat(relevantId, "/?forceInApp=true").concat(variationSegment, "#type=item&tracking_id=").concat(trackingId, "&source=eshops&d2id=").concat(d2id);
  }
  return "meli://products/".concat(relevantId, "/?forceInApp=true#type=product&tracking_id=").concat(trackingId, "&source=eshops&d2id=").concat(d2id);
};
var navigation = function navigation(_ref) {
  var itemLink = _ref.itemLink,
    relevantId = _ref.relevantId,
    relevantType = _ref.relevantType,
    trackingId = _ref.trackingId,
    isWebview = _ref.isWebview,
    variationId = _ref.variationId,
    d2id = _ref.d2id;
  if (isWebview) {
    var url = itemLink;
    if (!isDeepLink$1(itemLink)) {
      url = newDeepLink(relevantId, relevantType, trackingId, variationId, d2id);
    } else {
      url = "".concat(itemLink, "&d2id=").concat(d2id);
    }
    window.MobileWebKit.navigation.push(url)["catch"](function () {
      window.location = url;
    });
  } else {
    window.location = "".concat(itemLink, "&d2id=").concat(d2id);
  }
};
var navigationTo = function navigationTo(props) {
  var url = props.itemLink,
    isWebview = props.isWebview,
    relevant = props.relevant;
  if (relevant) {
    navigation(_objectSpread2({}, props));
    return;
  }
  if (isWebview && isDeepLink$1(url)) {
    window.MobileWebKit.navigation.push(url)["catch"](function () {
      window.location = url;
    });
    return;
  }
  window.location = url;
};
var isOnlyLine = function isOnlyLine(str) {
  return str.length <= 25;
};
var _svg;
var CouponIcon = function CouponIcon() {
  return _svg || (_svg = /*#__PURE__*/_createRawReactElement$1("svg", {
    width: "13",
    height: "11",
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "coupon-icon"
  }, void 0, /*#__PURE__*/_createRawReactElement$1("path", {
    d: "M2 0.5H11C11.8284 0.5 12.5 1.17157 12.5 2V2.99152C12.5 3.08948 12.4263 3.17177 12.329 3.18259C10.0938 3.43094 10.0938 6.68017 12.329 6.92852C12.4263 6.93934 12.5 7.02163 12.5 7.11959V8.11111C12.5 8.93954 11.8284 9.61111 11 9.61111H2C1.17157 9.61111 0.5 8.93954 0.5 8.11111V2C0.5 1.17157 1.17157 0.5 2 0.5Z",
    stroke: "#3483FA"
  }), /*#__PURE__*/_createRawReactElement$1("path", {
    d: "M8.17582 4.20402L6.83448 4.09671C6.78082 4.09671 6.72717 4.06094 6.70928 4.00729L6.20852 2.75537C6.08332 2.45133 5.67198 2.45133 5.54679 2.75537L5.04602 4.00729C5.02814 4.06094 4.97448 4.09671 4.92083 4.09671L3.57949 4.18613C3.25757 4.20402 3.13237 4.61536 3.38276 4.81209L4.40218 5.67055C4.43795 5.70632 4.45583 5.75997 4.45583 5.81363L4.11603 7.13708C4.04449 7.44112 4.38429 7.6915 4.65256 7.53054L5.79717 6.81516C5.85083 6.77939 5.90448 6.77939 5.95813 6.81516L7.10274 7.53054C7.37101 7.6915 7.71082 7.45901 7.63928 7.13708L7.29947 5.83151C7.28159 5.77786 7.29947 5.72421 7.35313 5.68844L8.39043 4.81209C8.62293 4.61536 8.49774 4.2219 8.17582 4.20402Z",
    fill: "#3483FA"
  })));
};
var CouponIcon$1 = CouponIcon;
var _CouponIcon;
var RebatesPill = function RebatesPill(_ref) {
  var rebates = _ref.rebates,
    namespace = _ref.namespace;
  if (!(rebates !== null && rebates !== void 0 && rebates.label)) {
    return null;
  }
  return /*#__PURE__*/_createRawReactElement$1("p", {
    className: "".concat(namespace, "__rebates-container"),
    "aria-label": rebates.accessibility_text || rebates.label
  }, void 0, /*#__PURE__*/_createRawReactElement$1("span", {
    className: "".concat(namespace, "__rebates-pill")
  }, void 0, (rebates === null || rebates === void 0 ? void 0 : rebates.has_icon) && (_CouponIcon || (_CouponIcon = /*#__PURE__*/_createRawReactElement$1(CouponIcon$1, {
    "aria-hidden": "true"
  }))), rebates.label));
};
var RebatesPill$1 = RebatesPill;
var isNotEmpty = function isNotEmpty(value) {
  return !!value && typeof value === 'string' && (value === null || value === void 0 ? void 0 : value.trim()) !== '';
};
var makeStyles = function makeStyles(styles, eshopItemNamespace, highlightNamespace) {
  var _ref = styles !== null && styles !== void 0 ? styles : {},
    _ref$color_schema = _ref.color_schema,
    colorSchema = _ref$color_schema === void 0 ? 'gray' : _ref$color_schema,
    colorHex = _ref.color_hex,
    backgroundColorHex = _ref.background_color_hex;
  var hasStyle = isNotEmpty(colorHex) && isNotEmpty(backgroundColorHex);
  var style = hasStyle ? {
    color: colorHex,
    backgroundColor: backgroundColorHex
  } : {};
  var highlightPillClass = classNames("".concat(eshopItemNamespace, "__").concat(highlightNamespace), _defineProperty({}, "".concat(eshopItemNamespace, "__").concat(highlightNamespace, "--").concat(colorSchema), !hasStyle));
  return {
    className: highlightPillClass,
    style: style
  };
};
var namespace = 'highlight-pill';
var HighlightPill = function HighlightPill(_ref) {
  var children = _ref.children,
    styles = _ref.styles,
    eshopItemNamespace = _ref.namespace;
  var _makeStyles = makeStyles(styles, eshopItemNamespace, namespace),
    className = _makeStyles.className,
    style = _makeStyles.style;
  return /*#__PURE__*/_createRawReactElement$1("div", {
    className: className
  }, void 0, /*#__PURE__*/_createRawReactElement$1("span", {
    style: style
  }, void 0, children));
};
var HighlightPill$1 = HighlightPill;
var _FullIcon;
var ESHOPS_STANDAR_CARD = [constants.TYPES.SELLER, constants.TYPES.BRAND, constants.TYPES.LANDING, constants.TYPES.SUPER, constants.TYPES.SUPER_PARTNER];
const EshopItem$2 = /*#__PURE__*/function () {
  const EshopItem = function EshopItem(_ref) {
    var _variationsData$, _span, _span2, _span3;
    var item = _ref.item,
      layout = _ref.layout,
      relevant = _ref.relevant,
      cta = _ref.cta,
      addBookmarkLabel = _ref.addBookmarkLabel,
      onClickBookmark = _ref.onClickBookmark,
      onClickCta = _ref.onClickCta,
      addItem = _ref.addItem,
      updateItem = _ref.updateItem,
      deleteItem = _ref.deleteItem,
      eshopType = _ref.eshopType,
      itemImage = _ref.itemImage,
      setItemImage = _ref.setItemImage,
      itemLink = _ref.itemLink,
      setItemLink = _ref.setItemLink,
      itemName = _ref.itemName,
      setItemName = _ref.setItemName,
      variationId = _ref.variationId,
      setVariationId = _ref.setVariationId,
      trackingId = _ref.trackingId,
      sortedVariationData = _ref.sortedVariationData,
      isWebview = _ref.isWebview,
      deviceType = _ref.deviceType,
      variationsCta = _ref.variationsCta,
      osName = _ref.osName,
      cartItemQuantity = _ref.cartItemQuantity,
      geolocatedQuantity = _ref.geolocatedQuantity,
      cartTextLabel = _ref.cartTextLabel,
      tabIndex = _ref.tabIndex,
      seeElements = _ref.seeElements,
      d2id = _ref.d2id,
      userZipCode = _ref.userZipCode,
      trackEvent = _ref.trackEvent,
      trackingData = _ref.trackingData,
      hasFreeOrPromisedShippingItem = _ref.hasFreeOrPromisedShippingItem,
      shouldHaveAutoHeight = _ref.shouldHaveAutoHeight,
      isPurchaseMinQuantityLabel = _ref.isPurchaseMinQuantityLabel,
      isSupermarketShop = _ref.isSupermarketShop;
    var availableQuantity = item.available_quantity,
      maxAddToCartQuantity = item.max_add_to_cart_quantity,
      id = item.id,
      title = item.title,
      price = item.price,
      shipping = item.shipping,
      bookmarked = item.bookmarked,
      freeShippingLabel = item.free_shipping_label,
      priceDiscount = item.price_discount,
      installments = item.installments,
      installmentsData = item.installments_data,
      permalink = item.permalink;
    item.installment_has_interest;
    var relevantId = item.relevant_id,
      relevantType = item.relevant_type,
      saleTerms = item.sale_terms,
      variationsQty = item.variations_qty,
      variationsData = item.variations_data,
      floatHighlight = item.float_highlight,
      rebates = item.rebates,
      pum = item.pum;
    var value = price.value,
      whole = price.whole,
      decimals = price.decimals,
      currencySymbol = price.currency_symbol,
      currencyId = price.currency_id,
      originalPrice = price.original_price;
    var _ref2 = shipping || {},
      _ref2$promise = _ref2.promise,
      promise = _ref2$promise === void 0 ? '' : _ref2$promise,
      _ref2$badge = _ref2.badge,
      badge = _ref2$badge === void 0 ? null : _ref2$badge;
    var _ref3 = floatHighlight !== null && floatHighlight !== void 0 ? floatHighlight : {},
      highlightText = _ref3.text,
      highlightStyles = _ref3.styles;
    var isMobile = deviceType === 'mobile';
    var isSuper = isSupermarketShop || (eshopType === null || eshopType === void 0 ? void 0 : eshopType.includes('super'));
    var isFullSuper = eshopType === 'super';
    var amount = {
      fraction: whole,
      cents: (decimals === null || decimals === void 0 ? void 0 : decimals.length) === 1 ? "".concat(decimals, "0") : decimals,
      symbol: currencySymbol
    };
    var variation = (variationsData === null || variationsData === void 0 ? void 0 : variationsData.length) > 0 ? (_variationsData$ = variationsData[0]) === null || _variationsData$ === void 0 ? void 0 : _variationsData$.id : '';
    var namespace = 'ui-eshop-item';
    var checkVariation = (sortedVariationData === null || sortedVariationData === void 0 ? void 0 : sortedVariationData.length) > 0 && relevant === true;
    var LinkItemWrapper = 'div';
    var _ref4 = saleTerms || {},
      purchaseMinQuantity = _ref4.purchase_min_quantity,
      purchaseMaxQuantity = _ref4.purchase_max_quantity,
      minLabel = _ref4.purchase_min_quantity_label,
      netWeight = _ref4.net_weight;
    var _useState = useState(cartItemQuantity),
      _useState2 = _slicedToArray(_useState, 2),
      itemQuantity = _useState2[0],
      setItemQuantity = _useState2[1];
    var _useState3 = useState(cartItemQuantity ? 'update' : 'add'),
      _useState4 = _slicedToArray(_useState3, 2),
      updateAction = _useState4[0],
      setUpdateAction = _useState4[1];
    var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      quantityUpdateId = _useState6[0],
      setQuantityUpdateId = _useState6[1];
    var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      initialValue = _useState8[0],
      setInitial = _useState8[1];
    var handleCtaClick = function handleCtaClick(event) {
      var blockRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      event.stopPropagation();
      if (onClickCta) {
        onClickCta();
      }
      if (itemLink) {
        if (trackEvent && trackingData) {
          trackEvent(trackingData);
        }
        if (blockRedirect) {
          return;
        }
        navigationTo({
          itemLink: itemLink,
          relevantId: relevantId,
          relevantType: relevantType,
          trackingId: trackingId,
          isWebview: isWebview,
          variationId: variationId,
          relevant: relevant,
          d2id: d2id
        });
      }
    };
    var addToCart = function addToCart(minQuantity) {
      if (cartItemQuantity > 0) {
        setUpdateAction('update');
      } else {
        setUpdateAction('add');
      }
      setItemQuantity(minQuantity);
    };
    var handleQuantityIncrement = function handleQuantityIncrement() {
      var newQuantity = itemQuantity + 1;
      return setItemQuantity(newQuantity);
    };
    var handleQuantityDecrement = function handleQuantityDecrement() {
      var newQuantity = itemQuantity - 1;
      if (newQuantity === 0 || purchaseMinQuantity && newQuantity < purchaseMinQuantity) {
        setUpdateAction('delete');
        return setItemQuantity(0);
      }
      setUpdateAction('update');
      return setItemQuantity(newQuantity);
    };
    useEffect(function () {
      if (initialValue) {
        setInitial(false);
        return;
      }
      if (quantityUpdateId !== null) {
        clearTimeout(quantityUpdateId);
      }
      var timeoutId = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee() {
        var cartPromise, success;
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cartPromise = updateAction === 'update' ? updateItem : addItem;
              if (!(itemQuantity === 0)) {
                _context.next = 5;
                break;
              }
              if (!(updateAction === 'add')) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              cartPromise = deleteItem;
            case 5:
              _context.next = 7;
              return cartPromise(id, itemQuantity, variation);
            case 7:
              success = _context.sent;
              if (!success) {
                setInitial(true);
                setItemQuantity(cartItemQuantity || 0);
              }
              setUpdateAction(itemQuantity > 0 ? 'update' : 'add');
              clearTimeout(quantityUpdateId);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), 700);
      setQuantityUpdateId(timeoutId);
    }, [itemQuantity]);
    var hasMoreVariations = variationsQty && variationsQty !== null && variationsQty > 1;
    var hideActionBtn = !seeElements.action_card || !relevant && !userZipCode;
    var shouldAddToCart = function shouldAddToCart(event) {
      return !hasMoreVariations && !relevant ? addToCart(purchaseMinQuantity !== null && purchaseMinQuantity !== void 0 ? purchaseMinQuantity : 1) : handleCtaClick(event);
    };
    var classBadgeType = classNames(_defineProperty(_defineProperty({}, "".concat(namespace, "__shipping-free--badge-").concat(badge), badge === 'quiet' || badge === 'loud'), "".concat(namespace, "__shipping-free"), badge === null));
    var classContent = classNames("".concat(namespace, "__content ").concat(namespace, "__content--").concat(layout), _defineProperty({}, "".concat(namespace, "__content--super-auto-height"), isSuper));
    var renderShippingTag = function renderShippingTag() {
      if (promise) {
        var firsLine = promise;
        var secondLine = null;
        var promiseSplit = promise.split(' ');
        if (promiseSplit.length > 3 && relevant !== true) {
          secondLine = promiseSplit[promiseSplit.length - 1];
          firsLine = firsLine.replace(secondLine, '');
        }
        if (secondLine) {
          if (!isMobile && isOnlyLine(promise)) {
            return _span || (_span = /*#__PURE__*/_createRawReactElement$1("span", {
              className: classBadgeType
            }, void 0, promise));
          }
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_createRawReactElement$1("span", {
            className: classBadgeType
          }, void 0, firsLine), /*#__PURE__*/_createRawReactElement$1("span", {
            className: classBadgeType
          }, void 0, secondLine));
        }
        return _span2 || (_span2 = /*#__PURE__*/_createRawReactElement$1("span", {
          className: classBadgeType
        }, void 0, promise));
      }
      if (freeShippingLabel) {
        return _span3 || (_span3 = /*#__PURE__*/_createRawReactElement$1("span", {
          className: "".concat(namespace, "__shipping-free")
        }, void 0, freeShippingLabel));
      }
      return null;
    };
    var installmentsElement = null;
    if (installments !== null && installmentsData !== null) {
      var _generateInstallments = generateInstallments(installments, installmentsData),
        hasInterest = _generateInstallments.hasInterest,
        hasInString = _generateInstallments.hasInString;
      var classInstallments = classNames("".concat(namespace, "__installments"), _defineProperty({}, "".concat(namespace, "__installments--interest"), hasInterest));
      var createInstallmentsElement = function createInstallmentsElement(insideElement) {
        return /*#__PURE__*/_createRawReactElement$1("p", {
          className: classInstallments
        }, void 0, insideElement);
      };
      if (hasInString) {
        var inString = installments.slice(0, 2);
        var installmentString = installments.slice(2);
        var insideElement = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_createRawReactElement$1("span", {
          className: "ui-eshop-item__installments--in"
        }, void 0, inString), installmentString);
        installmentsElement = createInstallmentsElement(insideElement);
      } else {
        installmentsElement = createInstallmentsElement(installments);
      }
    }
    var clickAllCard = function clickAllCard(event) {
      return relevant !== true ? handleCtaClick(event, true) : null;
    };
    var showPreviousValue = originalPrice > value && (relevant === true || ESHOPS_STANDAR_CARD.includes(eshopType));
    var showInstallments = relevant === true || ESHOPS_STANDAR_CARD.includes(eshopType);
    var classCardItem = classNames("".concat(namespace, "__card--").concat(layout), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(namespace, "__card--not-relevant"), relevant !== true), 'native--ios', osName && osName.toLowerCase() === 'ios' || isWebview && osName === undefined), "".concat(namespace, "--without-action"), !(seeElements !== null && seeElements !== void 0 && seeElements.action_card) || !userZipCode), "".concat(namespace, "__card--seller"), ESHOPS_STANDAR_CARD.includes(eshopType)), "".concat(namespace, "__card--auto-height"), hasFreeOrPromisedShippingItem && isPurchaseMinQuantityLabel && !hideActionBtn ? false : (!hideActionBtn || shouldHaveAutoHeight) && isSuper), "".concat(namespace, "__card--flex-column"), isSuper));
    var ImageClassNames = classNames("".concat(namespace, "__image_container ").concat(namespace, "__image_container--").concat(layout), _defineProperty({}, "".concat(namespace, "__image_container--line"), layout === 'column' && !relevant));
    var actionWrapperClasses = classNames("".concat(namespace, "__item-cta"));
    var minSalesClassNames = classNames("".concat(namespace, "__min-sales"), _defineProperty({}, "".concat(namespace, "__min-sales--hidden"), isSuper && !isPurchaseMinQuantityLabel));
    var shippingClass = classNames("".concat(namespace, "__shipping"), _defineProperty({}, "".concat(namespace, "__shipping--super"), isSuper));
    var shippingTag = classNames(_defineProperty({}, "".concat(namespace, "__shipping--super"), isSuper && hasFreeOrPromisedShippingItem));
    var getMaxPurchaseQuantity = function getMaxPurchaseQuantity() {
      var maxAvailable = isFullSuper && geolocatedQuantity ? geolocatedQuantity : maxAddToCartQuantity || availableQuantity;
      return purchaseMaxQuantity !== null && purchaseMaxQuantity <= maxAvailable ? purchaseMaxQuantity : maxAvailable;
    };
    return /*#__PURE__*/_createRawReactElement$1(Card, {
      shadow: "elevated",
      className: classCardItem
    }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {
      className: ImageClassNames,
      tabIndex: tabIndex
    }, void 0, /*#__PURE__*/_createRawReactElement$1(LinkItemWrapper, {
      className: "".concat(namespace, "__image-link"),
      onClick: function onClick(event) {
        return handleCtaClick(event, true);
      },
      "data-testid": "image-wrapper"
    }, void 0, /*#__PURE__*/_createRawReactElement$1("a", {
      href: itemLink,
      "data-testid": "image-anchor"
    }, void 0, /*#__PURE__*/_createRawReactElement$1(Image$1, {
      src: itemImage,
      lazyload: "on",
      alt: title,
      className: "".concat(namespace, "__image")
    }))), onClickBookmark && /*#__PURE__*/_createRawReactElement$1(BookmarkButton$1, {
      onClickBookmark: onClickBookmark,
      bookmarked: bookmarked,
      addBookmarkLabel: addBookmarkLabel
    }), isNotEmpty(highlightText) && /*#__PURE__*/_createRawReactElement$1(HighlightPill$1, {
      namespace: namespace,
      styles: highlightStyles
    }, void 0, highlightText)), /*#__PURE__*/_createRawReactElement$1("div", {
      className: classContent
    }, void 0, /*#__PURE__*/_createRawReactElement$1("div", {}, void 0, /*#__PURE__*/_createRawReactElement$1("a", {
      className: "".concat(namespace, "__data ").concat(namespace, "__data--").concat(layout),
      href: itemLink,
      onClick: function onClick(event) {
        return clickAllCard(event);
      },
      role: "button",
      "data-testid": "detail-anchor"
    }, void 0, checkVariation && /*#__PURE__*/_createRawReactElement$1(Variations$1, {
      sortedVariationData: sortedVariationData,
      layout: layout,
      setItemLink: setItemLink,
      itemImage: itemImage,
      setItemImage: setItemImage,
      itemName: itemName,
      setItemName: setItemName,
      trackingId: trackingId,
      permalink: permalink,
      variationId: variationId,
      setVariationId: setVariationId,
      onClick: function onClick(event) {
        return handleCtaClick(event, true);
      }
    }), /*#__PURE__*/_createRawReactElement$1(LinkItemWrapper, {
      className: "".concat(namespace, "__link"),
      onClick: function onClick(event) {
        return handleCtaClick(event, true);
      },
      "data-testid": "title-wrapper"
    }, void 0, /*#__PURE__*/_createRawReactElement$1("h3", {
      className: "".concat(namespace, "__title")
    }, void 0, title)), /*#__PURE__*/_createRawReactElement$1(LinkItemWrapper, {
      className: "".concat(namespace, "__numbers ").concat(namespace, "__link"),
      onClick: function onClick(event) {
        return handleCtaClick(event, true);
      },
      "data-testid": "detail-wrapper"
    }, void 0, /*#__PURE__*/_createRawReactElement$1(MoneyAmountCombo, {
      className: "".concat(namespace, "__link"),
      previousValue: showPreviousValue ? {
        centsType: 'superscript',
        currencyId: currencyId,
        value: {
          fraction: formatNumber(originalPrice, currencyId),
          symbol: currencySymbol
        }
      } : null,
      currentValue: {
        centsType: 'superscript',
        currencyId: currencyId,
        value: amount,
        size: deviceType === 'mobile' && relevant !== true ? 18 : 24
      },
      discount: priceDiscount && {
        value: priceDiscount,
        size: deviceType === 'mobile' && relevant !== true ? 10 : undefined
      }
    }), showInstallments && /*#__PURE__*/React.createElement(React.Fragment, null, installmentsElement), promise || shipping.fulfillment ? /*#__PURE__*/_createRawReactElement$1("div", {
      className: shippingClass
    }, void 0, renderShippingTag(), shipping.fulfillment && (_FullIcon || (_FullIcon = /*#__PURE__*/_createRawReactElement$1(Full, {
      className: "".concat(namespace, "__full"),
      color: "#00a650",
      width: "40px",
      height: "16px"
    })))) : /*#__PURE__*/_createRawReactElement$1("div", {
      className: shippingTag
    }))), (pum === null || pum === void 0 ? void 0 : pum.text) && /*#__PURE__*/_createRawReactElement$1("p", {
      className: "".concat(namespace, "__pum")
    }, void 0, pum.text), /*#__PURE__*/_createRawReactElement$1(RebatesPill$1, {
      rebates: rebates,
      namespace: namespace
    })), !hideActionBtn && /*#__PURE__*/_createRawReactElement$1("div", {
      className: actionWrapperClasses
    }, void 0, /*#__PURE__*/_createRawReactElement$1(CardAction$1, {
      namespace: namespace,
      layout: layout,
      shouldAddToCart: shouldAddToCart,
      relevant: relevant,
      variationsCta: variationsCta,
      cta: cta,
      itemQuantity: itemQuantity,
      hasMoreVariations: hasMoreVariations,
      netWeight: netWeight,
      purchaseMaxQuantity: getMaxPurchaseQuantity(),
      incrementQuantity: handleQuantityIncrement,
      decrementQuantity: handleQuantityDecrement,
      deviceType: deviceType,
      cartTextLabel: cartTextLabel,
      osName: osName
    }), !relevant && /*#__PURE__*/_createRawReactElement$1("span", {
      className: minSalesClassNames
    }, void 0, minLabel || ''))));
  };
  EshopItem.defaultProps = {
    layout: 'column',
    relevant: false,
    onClickBookmark: null,
    onClickCta: null,
    addBookmarkLabel: 'Favorito',
    trackingId: 'none',
    item: [{
      sale_terms: {
        purchase_min_quantity: 0,
        purchase_max_quantity: undefined
      },
      installments_data: {
        rate: 0
      }
    }],
    isWebview: false,
    seeElements: {
      action_card: true
    },
    d2id: '',
    eshopType: '',
    trackingData: null,
    trackEvent: null,
    hasFreeOrPromisedShippingItem: false,
    shouldHaveAutoHeight: false,
    isPurchaseMinQuantityLabel: true
  };
  return EshopItem;
}();
var EshopItemContainer = EshopItem$2;
var moveElementToFirst = function moveElementToFirst() {
  var variationsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var picture = arguments.length > 1 ? arguments[1] : undefined;
  var valor = picture === null || picture === void 0 ? void 0 : picture.src.split('-')[1];
  var newVariationdata = Array.from(variationsData);
  newVariationdata.sort(function (a, b) {
    if (a.image.includes(valor)) {
      return -1;
    }
    if (b.image.includes(valor)) {
      return 1;
    }
    return 0;
  });
  return newVariationdata;
};
var moveElementToFirst$1 = moveElementToFirst;
var _excluded = ["item", "metrics", "deviceType", "relevant"];
const EshopItem = /*#__PURE__*/function () {
  const EshopItem = function EshopItem(_ref) {
    var item = _ref.item,
      metrics = _ref.metrics,
      deviceType = _ref.deviceType,
      relevant = _ref.relevant,
      props = _objectWithoutProperties(_ref, _excluded);
    var permalink = item.permalink,
      picture = item.picture,
      variationsData = item.variations_data;
    var trackingId = metrics === null || metrics === void 0 ? void 0 : metrics.tracking_id;
    var checkVariation = (variationsData === null || variationsData === void 0 ? void 0 : variationsData.length) > 1 && relevant;
    var newPermalink = permalink.replace('{tracking_id}', trackingId);
    var sortedVariationData = checkVariation ? moveElementToFirst$1(variationsData, picture) : [];
    var getImageInHttps = function getImageInHttps(imageUrl) {
      return imageUrl.replace('http://', 'https://');
    };
    var _useState = useState(checkVariation ? getImageInHttps(sortedVariationData[0].image) : getImageInHttps(picture.src)),
      _useState2 = _slicedToArray(_useState, 2),
      itemImage = _useState2[0],
      setItemImage = _useState2[1];
    var _useState3 = useState(newPermalink),
      _useState4 = _slicedToArray(_useState3, 2),
      itemLink = _useState4[0],
      setItemLink = _useState4[1];
    var _useState5 = useState(checkVariation ? sortedVariationData[0].name : ''),
      _useState6 = _slicedToArray(_useState5, 2),
      itemName = _useState6[0],
      setItemName = _useState6[1];
    var _useState7 = useState(checkVariation ? sortedVariationData[0].id : null),
      _useState8 = _slicedToArray(_useState7, 2),
      variationId = _useState8[0],
      setVariationId = _useState8[1];
    return /*#__PURE__*/React.createElement(EshopItemContainer, _extends({}, props, {
      item: _objectSpread2(_objectSpread2({}, item), {}, {
        permalink: newPermalink
      }),
      sortedVariationData: checkVariation ? sortedVariationData : [],
      itemImage: itemImage,
      setItemImage: setItemImage,
      itemLink: itemLink,
      setItemLink: setItemLink,
      itemName: itemName,
      setItemName: setItemName,
      variationId: variationId,
      setVariationId: setVariationId,
      trackingId: trackingId,
      deviceType: deviceType
    }));
  };
  EshopItem.defaultProps = {
    layout: 'column',
    relevant: false,
    onClickBookmark: null,
    onClickCta: null,
    addBookmarkLabel: 'Favorito',
    metrics: {
      tracking_id: 'none',
      item_id: ''
    }
  };
  return EshopItem;
}();
var EshopItem$1 = EshopItem;
export { EshopItem$1 as EshopItem, EshopItem$1 as default };
